// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Controller Rollout API
 * Fleet-wide view and control of Rollout CRDs across orchestras
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResponseStepPhase } from './ResponseStepPhase';
import {
  ResponseStepPhaseFromJSON,
  ResponseStepPhaseFromJSONTyped,
  ResponseStepPhaseToJSON,
  ResponseStepPhaseToJSONTyped,
} from './ResponseStepPhase';
import type { ResponseResourceProgress } from './ResponseResourceProgress';
import {
  ResponseResourceProgressFromJSON,
  ResponseResourceProgressFromJSONTyped,
  ResponseResourceProgressToJSON,
  ResponseResourceProgressToJSONTyped,
} from './ResponseResourceProgress';

/**
 *
 * @export
 * @interface ResponseClusterCompletionStepDetail
 */
export interface ResponseClusterCompletionStepDetail {
  /**
   *
   * @type {string}
   * @memberof ResponseClusterCompletionStepDetail
   */
  completedAt?: string;
  /**
   *
   * @type {string}
   * @memberof ResponseClusterCompletionStepDetail
   */
  name?: string;
  /**
   *
   * @type {ResponseStepPhase}
   * @memberof ResponseClusterCompletionStepDetail
   */
  phase?: ResponseStepPhase;
  /**
   *
   * @type {Array<ResponseResourceProgress>}
   * @memberof ResponseClusterCompletionStepDetail
   */
  resourceProgresses?: Array<ResponseResourceProgress>;
  /**
   *
   * @type {string}
   * @memberof ResponseClusterCompletionStepDetail
   */
  startedAt?: string;
  /**
   *
   * @type {string}
   * @memberof ResponseClusterCompletionStepDetail
   */
  transferFinishedAt?: string;
  /**
   *
   * @type {string}
   * @memberof ResponseClusterCompletionStepDetail
   */
  transferStartedAt?: string;
}

/**
 * Check if a given object implements the ResponseClusterCompletionStepDetail interface.
 */
export function instanceOfResponseClusterCompletionStepDetail(
  value: object,
): value is ResponseClusterCompletionStepDetail {
  return true;
}

export function ResponseClusterCompletionStepDetailFromJSON(
  json: any,
): ResponseClusterCompletionStepDetail {
  return ResponseClusterCompletionStepDetailFromJSONTyped(json, false);
}

export function ResponseClusterCompletionStepDetailFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseClusterCompletionStepDetail {
  if (json == null) {
    return json;
  }
  return {
    completedAt: json['completedAt'] == null ? undefined : json['completedAt'],
    name: json['name'] == null ? undefined : json['name'],
    phase:
      json['phase'] == null
        ? undefined
        : ResponseStepPhaseFromJSON(json['phase']),
    resourceProgresses:
      json['resourceProgresses'] == null
        ? undefined
        : (json['resourceProgresses'] as Array<any>).map(
            ResponseResourceProgressFromJSON,
          ),
    startedAt: json['startedAt'] == null ? undefined : json['startedAt'],
    transferFinishedAt:
      json['transferFinishedAt'] == null
        ? undefined
        : json['transferFinishedAt'],
    transferStartedAt:
      json['transferStartedAt'] == null ? undefined : json['transferStartedAt'],
  };
}

export function ResponseClusterCompletionStepDetailToJSON(
  json: any,
): ResponseClusterCompletionStepDetail {
  return ResponseClusterCompletionStepDetailToJSONTyped(json, false);
}

export function ResponseClusterCompletionStepDetailToJSONTyped(
  value?: ResponseClusterCompletionStepDetail | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    completedAt: value['completedAt'],
    name: value['name'],
    phase: ResponseStepPhaseToJSON(value['phase']),
    resourceProgresses:
      value['resourceProgresses'] == null
        ? undefined
        : (value['resourceProgresses'] as Array<any>).map(
            ResponseResourceProgressToJSON,
          ),
    startedAt: value['startedAt'],
    transferFinishedAt: value['transferFinishedAt'],
    transferStartedAt: value['transferStartedAt'],
  };
}
